function SvgComponent(props: any) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.3643 4.36328H5.45517C4.85267 4.36328 4.36426 4.8517 4.36426 5.45419V10.3633C4.36426 10.9658 4.85267 11.4542 5.45517 11.4542H10.3643C10.9668 11.4542 11.4552 10.9658 11.4552 10.3633V5.45419C11.4552 4.8517 10.9668 4.36328 10.3643 4.36328Z"
        stroke="black"
        stroke-width="1.09091"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.18226 7.63583H1.63681C1.34748 7.63583 1.07 7.5209 0.865418 7.31631C0.660833 7.11173 0.545898 6.83425 0.545898 6.54492V1.63583C0.545898 1.3465 0.660833 1.06903 0.865418 0.864442C1.07 0.659857 1.34748 0.544922 1.63681 0.544922L6.5459 0.544922C6.83523 0.544922 7.1127 0.659857 7.31729 0.864442C7.52187 1.06903 7.63681 1.3465 7.63681 1.63583V2.18129"
        stroke="black"
        stroke-width="1.09091"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
export default SvgComponent;
